import { useQuery, useMutation } from '@tanstack/react-query'
import client from '@/ports/api-client'
import { purchasePackage } from '@/models/plans/apis'

const getFilteredPackages = async ({ searchKey }: { searchKey: string }) => {
  try {
    return await client.get(`/catalogs/user/packages/list?searchKey=${searchKey}`, {
      noLoading: true
    })
  } catch (error) {
    throw error
  }
}

const useGetFilteredPackages = ({ searchKey }: { searchKey: string }) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [`packages-${searchKey}`],
    queryFn: () => getFilteredPackages({ searchKey }),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60000,
    enabled: !!searchKey
  })
  return { data, isLoading, error }
}

const getPackageList = async () => {
  try {
    return await client.get(`/catalogs/user/packages/list`, {
      noLoading: true
    })
  } catch (error) {
    throw error
  }
}

const useGetPackageList = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: [`package-list-all`],
    queryFn: () => getPackageList(),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60000
  })
  return { data, isLoading, error }
}

const usePurchasePromotion = () => {
  const purchasePromotion = useMutation({
    mutationFn: ({
      paymentMethodId,
      items,
      metadata
    }: {
      paymentMethodId: string
      items: { quantity: number; priceId: string }[]
      metadata: { pLink: string }
    }) => {
      return purchasePackage({
        payment_method_id: paymentMethodId,
        items,
        metadata
      })
    },
    onSuccess: async data => {}
  })

  return purchasePromotion
}

export default useGetPackageList

export { usePurchasePromotion, useGetFilteredPackages }
